<template>
  <div class="bg-white-wrapper">
    <div class="prodet-bg">
      <div class="container">
        <div class="prodet-box-a">
          <p>
            {{ courseInfo.courseName }}/{{ courseInfo.specialName }}/包含班级：
          </p>
          <p class="prodet-boxa-bg">正在播放</p>
          <div class="product-course">
            <span>{{ courseInfo.courseName }}</span>
          </div>
        </div>
        <div class="prodet-player clearfix">
          <div class="prodet-box-c">
            <video-player
              :width="800"
              :viewId="0"
               viewType="ppt"
              :loading="!isLoaded"
			  :tipText="noVideoText"
            ></video-player>
          </div>
          <div class="prodet-box-d clearfix">
            <div class="prodet-boxd-a">
			  <course-catalog v-if="currentSpecial.type == 1"></course-catalog>
			  <review-catalog v-if="currentSpecial.type == 2"></review-catalog>
            </div>
            <div class="prodet-boxd-b">
              <div class="prodet-pt-a">
                <Icon type="md-menu" />
                <p>目录</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoPlayer from "../../components/common/VideoPlayer";
import CourseCatalog from "../../components/mall/CourseCatalog";
import ReviewCatalog from "../../components/mall/ReviewCatalog";
import { siteMixin } from "../../utils/mixin";
import { mall, study } from "../../request";
import { saveBuyProduct } from "../../utils/localStorage";
export default {
  mixins: [siteMixin],
  data () {
    return {
      isLoaded: false,
      productInfo: {},
	  currentSpecial: {},
	  noVideoText: '',
      courseInfo: {
        teacherList: [],
      },
    };
  },
  mounted () {
    this.initProductOrCourseData();
  },
  methods: {
    initProductOrCourseData () {
      this.setIsBuy(false);
      const productId = this.$route.params.id;
      if (productId) {
        this.setProductId(productId);
        this.getProductInfo();
      } else {
        const courseId = this.$route.params.cid;
        //if(!courseId) this.$router.push(); 跳转到错误页
        this.setCourseId(courseId);
        this.getCourseInfo();
      }
      //console.log(productId);
    },
    //获取商品信息
    getProductInfo () {
      mall
        .getProductInfo(
          this.siteConfig.agencyId,
          this.productId,
          this.loginUser.userId ?? 0
        )
        .then((res) => {
          console.log("productInfo", res);
          if (res.status == 1) {
            this.productInfo = res.data.product;
            this.setCourseId(this.productInfo.courseSet.split(",")[0]);
            this.setCourseSpecialId(this.productInfo.cstIds.split(",")[0]);
			if (res.data.courseList && res.data.courseList.length > 0 && res.data.courseList[0].coursespecialtypeList.length > 0){
				this.currentSpecial = res.data.courseList[0].coursespecialtypeList[0]
			}
            this.getCourseInfo();
          }
        });
    },
    //获取课程信息，及用户是否购买过当前课程，以及获取课程目录
    getCourseInfo () {
      mall
        .getCourseInfo(this.courseId, 0, this.siteConfig.agencyId)
        .then((res) => {
          //console.log("courseInfo", res);
          if (res.status === 1) {
            this.courseInfo = res.data;
            this.getCourseCatalog();
            if (!this.courseSpecialId) {
              this.setCourseSpecialId(this.courseInfo.cstid);
            }
          }
        });
    },
    //获取课程目录
    getCourseCatalog () {
      mall.getCourseCatalog(
	     this.courseId,
		 this.courseSpecialId,
		 this.currentSpecial.type,
		 this.loginUser.userId,
		 this.siteConfig.agencyId).then((res) => {
        if (res.status === 1) {
          //this.courseCatalog = res.data;
          this.setCourseCatalog(res.data);
		  //无目录时处理
		  if (!res.data || res.data.length == 0) {
		    this.setCourseCatalog([])
		    this.setVideoId('')
		    if (this.currentSpecial.type === 2) {
		      this.noVideoText = '该班型视频正在准备中'
		    }
		  }
          //精讲视频
          if (this.currentSpecial.type === 1 && res.data && res.data.length > 0) {
            const one = res.data[0];
            if (one.childList.length > 0) {
              const two = one.childList[0];
              if (two.childList.length > 0) {
                const three = two.childList[0];
                if (three.isTryLook == 1) {
                  this.setVideoId(three.bVideoId);
                }
              }
            }
          }
		//串讲
		if (this.currentSpecial.type === 2 && res.data && res.data.length > 0) {
		  const reviewPptList = res.data[0].pptList
		  if (reviewPptList && reviewPptList.length > 0) {
		    this.setReviewCatalog(reviewPptList)
		    let current = reviewPptList[0]
		    if (current.isTryLook === 1) {
		      this.setPptId(current.PptId)
		      this.setVideoId(current.bVideoId)
		    }else{
			  this.noVideoText = "当前课程视频不支持试看，请购买后进行学习";
		    }
		  }
		}
       //END
	   }
      });
    },
    scrollToTab (item, index) {
      window.scroll({ top: 740, behavior: "smooth" });
    },
  },
  components: {
    VideoPlayer,
    CourseCatalog,
	ReviewCatalog,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
//播放位置
.prodet-bg {
  background: #2f3133;
  width: 100%;
  padding-bottom: 36px;
  .prodet-box-a {
    color: #fff;
    width: 100%;
    padding-top: 15px;
    p {
      height: 24px;
      line-height: 24px;
      font-size: 14px;
      display: inline-block;
      &.prodet-boxa-bg {
        background: #ff6a40;
        width: 80px;
        text-align: center;
        border-radius: 4px;
      }
    }
    .product-course {
      position: relative;
      display: inline-block;
      margin-left: 10px;
    }
  }
  .prodet-player {
    width: 100%;
    padding-top: 15px;
    .prodet-box-c {
      float: left;
      width: 800px;
      height: 500px;
      background: #e4ebef;
    }
    .prodet-box-d {
      float: left;
      width: 400px;
      height: 500px;
      background: #1f2123;
      .prodet-boxd-a {
        float: left;
        width: 325px;
        height: 500px;
        padding: 12px 12px 11px 12px;
      }
      .prodet-boxd-b {
        width: 75px;
        height: 500px;
        float: right;
        background: #000;
        position: relative;
        .prodet-pt-a {
          width: 92px;
          height: 56px;
          padding-left: 17px;
          padding-top: 3px;
          margin-left: -17px;
          background: url("../../assets/images/mall/project_ic_h-00.png");
          text-align: center;
          color: #fff;
          i {
            font-size: 2.5rem;
          }
          p {
            font-weight: bold;
          }
        }
        .prodet-pt-b {
          width: 75px;
          height: 56px;
          cursor: pointer;
          &:hover {
            background: #ff5423;
          }
          i {
            width: 25px;
            height: 25px;
            margin: 0 auto;
            display: block;
            padding-top: 4px;
          }
          p {
            text-align: center;
            font-size: 14px;
            color: #fff;
            padding-top: 6px;
          }
        }
      }
    }
  }
}
</style>